import { replaceInUrl, postRequest, putRequest, deleteRequest } from './index';
import apiEndpoints from './apiEndpoints';

export const createIraFundingAccountNumberRequest = ({
  ApplicationUid,
  data,
}) =>
  postRequest(
    replaceInUrl(apiEndpoints.custodians.custodianAccountNumber, {
      ApplicationUid,
    }),
    data,
  );

export const updateIraFundingAccountNumberRequest = ({
  ApplicationUid,
  data,
}) =>
  putRequest(
    replaceInUrl(apiEndpoints.custodians.custodianAccountNumber, {
      ApplicationUid,
    }),
    data,
  );

export const createIraFundingAmountRequest = ({ ApplicationUid, data }) =>
  postRequest(
    replaceInUrl(apiEndpoints.iraFunding.fundingAmount, {
      ApplicationUid,
    }),
    data,
  );

export const updateIraFundingAmountRequest = ({ ApplicationUid, data }) =>
  putRequest(
    replaceInUrl(apiEndpoints.iraFunding.fundingAmount, {
      ApplicationUid,
    }),
    data,
  );

export const createIraApplicationTransferTypeRequest = ({
  ApplicationUid,
  data,
  params,
}) =>
  postRequest(
    replaceInUrl(apiEndpoints.iraFunding.transferType, {
      ApplicationUid,
    }),
    data,
    params,
  );

export const updateIraApplicationTransferTypeRequest = ({
  ApplicationUid,
  data,
  params,
}) =>
  putRequest(
    replaceInUrl(apiEndpoints.iraFunding.transferType, {
      ApplicationUid,
    }),
    data,
    params,
  );

export const createIraApplicationFundingTypeRequest = ({
  ApplicationUid,
  data,
  params,
}) =>
  postRequest(
    replaceInUrl(apiEndpoints.iraFunding.fundingType, {
      ApplicationUid,
    }),
    data,
    params,
  );

export const updateIraApplicationFundingTypeRequest = ({
  ApplicationUid,
  data,
  params,
}) =>
  putRequest(
    replaceInUrl(apiEndpoints.iraFunding.fundingType, {
      ApplicationUid,
    }),
    data,
    params,
  );

export const deleteIraApplicationFundingRequest = ({
  ApplicationUid,
  data,
  params,
}) =>
  deleteRequest(
    replaceInUrl(apiEndpoints.iraFunding.fundingType, {
      ApplicationUid,
    }),
    data,
    params,
  );

export const createIraApplicationAccountTypeRequest = ({
  ApplicationUid,
  data,
  params,
}) =>
  postRequest(
    replaceInUrl(apiEndpoints.iraFunding.accountType, {
      ApplicationUid,
    }),
    data,
    params,
  );

export const updateIraApplicationAccountTypeRequest = ({
  ApplicationUid,
  data,
  params,
}) =>
  putRequest(
    replaceInUrl(apiEndpoints.iraFunding.accountType, {
      ApplicationUid,
    }),
    data,
    params,
  );

export const createIraApplicationPaymentDeliveryTypeRequest = ({
  ApplicationUid,
  data,
  params,
}) =>
  postRequest(
    replaceInUrl(apiEndpoints.iraFunding.paymentDeliveryType, {
      ApplicationUid,
    }),
    data,
    params,
  );

export const updateIraApplicationPaymentDeliveryTypeRequest = ({
  ApplicationUid,
  data,
  params,
}) =>
  putRequest(
    replaceInUrl(apiEndpoints.iraFunding.paymentDeliveryType, {
      ApplicationUid,
    }),
    data,
    params,
  );
